/*
 * Related Products — fetches Shopify's native product recommendations
 * for the current product and swaps them in for the skeleton grid.
 */
(function () {
  'use strict';

  function money(cents, format) {
    if (typeof cents !== 'number') return '';
    var amount = (cents / 100).toFixed(2);
    return (format || 'Rs. {{amount}}').replace('{{amount}}', amount);
  }

  function buildCard(product) {
    var a = document.createElement('a');
    a.className = 'rel-card';
    a.href = product.url;

    var media = document.createElement('div');
    media.className = 'rel-card-media';

    var img = document.createElement('img');
    img.className = 'rel-card-img';
    img.loading = 'lazy';
    img.alt = product.featured_image ? product.title : '';
    img.src = product.featured_image || '';
    media.appendChild(img);

    if (product.compare_at_price_max > product.price) {
      var badge = document.createElement('span');
      badge.className = 'rel-card-badge';
      badge.textContent = 'Sale';
      media.appendChild(badge);
    }

    var title = document.createElement('p');
    title.className = 'rel-card-title';
    title.textContent = product.title;

    var price = document.createElement('p');
    price.className = 'rel-card-price';
    price.textContent = money(product.price);
    if (product.compare_at_price_max > product.price) {
      var compare = document.createElement('span');
      compare.className = 'rel-card-price-compare';
      compare.textContent = money(product.compare_at_price_max);
      price.appendChild(compare);
    }

    a.appendChild(media);
    a.appendChild(title);
    a.appendChild(price);
    return a;
  }

  function loadRelated(wrapper) {
    var productId = wrapper.getAttribute('data-product-id');
    var limit = wrapper.getAttribute('data-product-limit') || 4;
    var grid = wrapper.querySelector('[data-rel-grid]');
    if (!productId || !grid) return;

    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit) + '&intent=related';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) {
          wrapper.style.display = 'none';
          return;
        }
        grid.innerHTML = '';
        products.forEach(function (product) {
          grid.appendChild(buildCard(product));
        });
      })
      .catch(function () {
        wrapper.style.display = 'none';
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-rel-wrapper][data-product-id]').forEach(loadRelated);
  });
})();
